import PropTypes from 'prop-types';
import styled from 'styled-components';

const ImageSwatch = styled.span`
  width: 22px;
  height: 22px;
  border-radius: 9999px;
  border: 1px solid black;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: ${({ imageUrl }) =>
    imageUrl ? `url('${imageUrl}')` : 'none'};
`;

ImageSwatch.propTypes = {
  imageUrl: PropTypes.string,
};

export default ImageSwatch;
